import React from "react";
import styles from "./GuideLine.module.scss";
import grass from "../../img/guideLine/grass.png";

const GuideLine = () => {
  return (
    <div className={styles.container}>
      <img src={grass} alt="grass" className={styles.background_img} />
      <h1 data-content="Qualification Guidelines">Qualification Guidelines</h1>
      <ul>
        <li>
          <span>Only games with less than 10k downloads.</span>
        </li>
        <li>
          <span>Must be over 18 to participate.</span>
        </li>
        <li>
          <span>Android submissions only.</span>
        </li>
        <li>
          <span>
            Must be submitted between Monday May 29th at 12:00 AM (UTC+0) and
            July 7th at 11:59 PM (UTC+0).
          </span>
        </li>
        <li>
          <span>
            Those from countries where remittance is permitted with the Republic
            of Korea.
          </span>
        </li>
        <li>
          <span>
            No games previously submitted through the MondayOFF Dashboard or
            currently under contract with MondayOFF.
          </span>
        </li>

        <div className={styles.link_area}>
          <p>For more information, read our</p>
          <a
            href="https://events.mondayoff.me/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms and Conditions
          </a>
        </div>
      </ul>
      <div className={styles.mondayoff}>
        <p>MondayOFF 2023</p>
        <p>MondayOFF Party - Summer splash</p>
      </div>
    </div>
  );
};

export default GuideLine;
